import { useGetWidgetName } from './useGetWidgetName';
import { useGetSearchType } from './useGetSearchType';
import { useUtmParams } from './useUtmParams';
import { useGetIsWhitelabel } from './useGetIsWhitelabel';
import { useGetWhitelabelName } from './useGetWhitelabelName';
import { useGetIsPassLtAflt } from './useGetIsPassLtAflt';

import { getWidgetNameInSnakeCase } from '../../../utils/tracker';

export const useGetBaseQueryParams = (): Record<string, string> | undefined => {
  const widgetName = useGetWidgetName();
  const searchType = useGetSearchType();
  const utmParams = useUtmParams();
  const isWhitelabel = useGetIsWhitelabel();
  const whitelabelName = useGetWhitelabelName();
  const isPassLtAflt = useGetIsPassLtAflt();

  if (!widgetName) {
    return;
  }

  const widgetNameForTracking = getWidgetNameInSnakeCase(widgetName, searchType);

  return {
    ...utmParams,
    ...(!isWhitelabel && (whitelabelName !== 'LT' || isPassLtAflt)
      ? {
          aflt: whitelabelName,
        }
      : {}),
    utm_source: whitelabelName,
    utm_medium: 'CPA',
    utm_campaign: 'widgets',
    utm_content: widgetNameForTracking,
  };
};
